import * as yup from "yup";

// Custom regex for fullName
const nameRegex = /^[a-zA-Z\s-']+$/;

export const ContactUsSchema = yup.object().shape({
  fullName: yup
    .string()
    .trim()
    .required("Full Name is required")
    .min(2, "Name must be at least 2 characters long")
    .matches(nameRegex, "Name can only contain letters, spaces, hyphens, and apostrophes"),

  email: yup
    .string()
    .trim()
    .required("Email is Required")
    .email("Invalid email address")
    .max(255, "Email must not exceed 255 characters"),

  phone: yup.string().trim().notRequired(),

  subject: yup
    .string()
    .trim()
    .required("Subject is required")
    .min(5, "Subject must be at least 5 characters long"),

  message: yup
    .string()
    .trim()
    .required("Message is required")
    .min(10, "Message must be at least 10 characters long")
    .max(1000, "Message must not exceed 1000 characters"),
});

export type ContactUsSchema = yup.InferType<typeof ContactUsSchema>;
